import {Component, Input, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Menu} from './interfaces/menu.interface';
import {ProfileSidebar} from './interfaces/profile-sidebar.interface';
import {UserService} from '../../../services/user.service';
import {LanguageService} from '../../../services/language.service';
import {environment} from '../../../../environments/environment';
import {FinancialService} from '../../../services/http/financial.service';
import {AuthService} from '../../../services/auth.service';
import {PrincipalService} from '../../../services/principal.service';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  displaySidebar: boolean = false;
  open: boolean = true;
  openProfile: boolean = false;
  logo: string = 'assets/img/login/logo-sendfy.svg';
  profile: ProfileSidebar = { submenus: [] };
  labelConsumption: string = '';
  activeRoute: string = '';

  environment = environment;

  @Input() hideSidebarRoute: string[];
  @Input() items: Menu[];
  @Input() profileMenu: Menu[];
  @Input() profileRoute: string;
  @Input() consumptionPercent: number = 0;

  constructor(
      private router: Router,
      public userService: UserService,
      public financialService: FinancialService,
      public authService: AuthService,
      public languageService: LanguageService,
      public principal: PrincipalService
  ) {
  }

  ngOnInit(): void {
      let found = false;

      this.router.events.subscribe(async (event) => {
          if (event instanceof NavigationEnd) {
              this.hideSidebarRoute.forEach(route => {
                  if (event.urlAfterRedirects.indexOf(route) >= 0) {
                      found = true;
                  }
              });

              this.labelConsumption = await this.languageService.translate('title.consumption');
              this.activeRoute = event.urlAfterRedirects;

              this.displaySidebar = !found;

              if (!found) {
                  if (!this.authService.getCompleteRegistration()) {
                      this.financialService.balance(this.authService.getCompany().id).subscribe(res => {
                          this.consumptionPercent = res.financeiro.consumoMes / res.financeiro.limiteMensal;
                          this.consumptionPercent = this.consumptionPercent > 1 ? 1 : this.consumptionPercent;
                      });
                  }
                  await this.userService.getProfile();
              }
          }
      });
  }

  collapse() {
    this.open = !this.open;
    this.logo = this.open ? 'assets/img/login/logo-sendfy.svg' : 'assets/img/login/logo-sendfy-icon.svg';
  }

  navigate(link: string) {
    this.router.navigate([link]);
  }

  changeOpenProfile() {
    this.openProfile = !this.openProfile;
  }

  // TODO: Remover no futuro

}
